import { createAuthClient } from '@storebrand-digital/auth';
import type { AuthOptions } from '@storebrand-digital/auth';

const options: AuthOptions = {
  config: {
    clientId: window.env.KEYCLOAK_CLIENT_ID,
    realm: window.env.KEYCLOAK_REALM,
    url: window.env.KEYCLOAK_URL,
  },
  init: {
    scope: window.env.KEYCLOAK_SCOPE,
  },
  login: {
    scope: window.env.KEYCLOAK_SCOPE,
  },
  logout: {
    redirectUri: window.env.KEYCLOAK_LOGOUT_URL,
  },
};

const auth = createAuthClient(options);

export default auth;
